<template>
  <div>
    <el-card shadow="always">
      <el-page-header title @back="$router.replace({ name: 'home' })"
        :content="$t('cockpit-faturamento')"></el-page-header>
    </el-card>
    <br />
     <el-card shadow="hover" v-if="userType !== '5'">
      <el-form :model="ruleForm" :inline="true" ref="ruleForm">
        <el-row :gutter="5" type="flex" justify="center">
          <el-col :span="12">
            <el-form-item :label="userType === '1' || userType === '3' ? $t('cliente') : $t('filial')" prop="customer">
              <CustomerList ref="customerList" v-model="ruleForm.customer" v-bind:customerType="userType === '2' ? 3 : 0" v-bind:multiple="false" @selected="clearSelection" />
            </el-form-item>
            <el-button type="primary" @click="fetchRecords()">Filtrar</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card v-if="tableData.length > 0">
      <el-row>
        <el-col :xs="14" :lg="14">
          <el-row type="flex" justify="center">
            <el-col :xs="20" :lg="20">
              <el-card class="border-nok" shadow="hover">
                <el-row :gutter="5">
                  <el-col :xs="10" :lg="10" class="text-center">
                    <el-link v-if="!payment" type="danger">Em aberto</el-link>
                    <el-link v-else type="success">Pago</el-link>
                    <br />
                    <span class="bold">{{ description }}</span>
                    <br />
                    <span v-if="!payment" class="description">Vencimento em {{ duedate }}</span>
                    <span v-else class="description">Pago em {{ duedate }}</span>
                  </el-col>
                  <el-col :xs="6" :lg="6" class="text-center">
                    <el-link class="valor" :type="!payment ? 'danger' : 'success'">{{ value }}</el-link>
                  </el-col>
                  <el-col :xs="8" :lg="8" class="text-right">
                    <el-link type="primary" class="description" @click="pdf(billet)">
                      Segunda via
                      <i class="el-icon-arrow-right el-icon--right"></i>
                    </el-link>
                    <br />
                    <el-link type="primary" class="description" @click="send">
                      Enviar por e-mail
                      <i class="el-icon-arrow-right el-icon--right"></i>
                    </el-link>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
          </el-row>
          <br />
          <el-row type="flex" justify="center">
            <el-col :xs="20" :lg="20">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>{{ $t("historico") }}</span>
                </div>
                <el-table :data="tableData" style="width: 100%" :default-sort="{ prop: 'name', order: 'ascending' }">
                  <el-table-column prop="duedate" :label="$t('vencimento')">
                    <template slot-scope="scope">
                      {{ scope.row.dueAt }}
                    </template>
                  </el-table-column>
                  <el-table-column sortable prop="value" :label="$t('valor')">
                    <template slot-scope="scope">{{ scope.row.value }}</template>
                  </el-table-column>
                  <el-table-column prop="paymentAt" :label="$t('pagamento')" />
                  <el-table-column width="120" label="#">
                    <template slot-scope="scope">
                      <el-button type="info" title="Boleto" icon="el-icon-download" @click="pdf(scope.row.invoice)"
                        circle></el-button>
                      <el-button type="success" v-if="scope.row.permission && scope.row.payment" title="Pagar" icon="el-icon-money"
                        @click="dopayment(scope.row.invoice, scope.row.value)" circle></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
        <PrepostLimitCredit ref="limitCredit" type="circle" :customer="ruleForm.customer"
          v-if="ruleForm.customer && limit > 0" />
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { i18n } from "@/plugin/i18n";
import { BilletService } from "@/services/customers/billet.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import moment from "moment";
import PrepostLimitCredit from "../services/pre.post/components/PrepostLimitCredit.vue";

export default {
  name: "CockpitBillingUser",
  components: {
    CustomerList,
    PrepostLimitCredit
  },
  methods: {
    fetchRecords() {
      const vm = this;
      if (!vm.ruleForm.customer) return false;
      const loading = vm.$loading(vm.$options.loading);
      BilletService.mybillets(vm.ruleForm.customer)
        .then((response) => {
          vm.tableData = response;
          if (vm.tableData.length > 0) {
            vm.limit = +vm.tableData[0].limit;
            vm.duedate = vm.tableData[0].payment === false ? vm.tableData[0].paymentAt : vm.tableData[0].dueAt;
            vm.value = vm.tableData[0].value;
            vm.month = vm.tableData[0].month;
            vm.billet = vm.tableData[0].invoice;
            vm.payment = vm.tableData[0].payment === false;
          }
          if (vm.ruleForm.customer === vm.$refs.customerList.selected) {
            this.showClearButton = true;
          } else {
            this.showClearButton = false;
          }
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    dopayment(id, value) {
      const vm = this;
      console.log('do payment', id)
      vm.$router.push({ name: 'financial.payment', query: { customer: vm.ruleForm.customer, type: 'circle', value: value, id: id } })
    },
    send() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      BilletService.mail()
        .then((response) => {
          vm.$message({
            type: "success",
            message: `E-mail enviado com sucesso!`,
          });
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    pdf(id) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      BilletService.pdf(id)
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `${id}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    clearSelection(id) {
      if(!id){
        this.ruleForm.customer = "";
        this.$refs.customerList.clear(); 
        this.tableData = []; 
        this.getDataCurrentUser();
      }
      
    },
    getDataCurrentUser() {
      const vm = this;
      UserService.me()
        .then((response) => {
          vm.userType = response.type;
          if (vm.userType == '2' || vm.userType === '5' || vm.userType === '3') {
            vm.ruleForm.customer = response.customers.id;
            vm.ruleForm.limit = +response.customers.limit;
          }
          vm.fetchRecords();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
      });
  }

  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
        if (vm.userType == '2' || vm.userType === '5' || vm.userType === '3') {
          vm.ruleForm.customer = response.customers.id;
          vm.ruleForm.limit = +response.customers.limit;
          
        }
        vm.fetchRecords();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
  computed: {
    description() {
      const vm = this;
      if (vm.month == 0) {
        return "Janeiro";
      } else if (vm.month == 1) {
        return "Fevereiro";
      } else if (vm.month == 2) {
        return "Março";
      } else if (vm.month == 3) {
        return "Abril";
      } else if (vm.month == 4) {
        return "Maio";
      } else if (vm.month == 5) {
        return "Junho";
      } else if (vm.month == 6) {
        return "Julho";
      } else if (vm.month == 7) {
        return "Agosto";
      } else if (vm.month == 8) {
        return "Setembro";
      } else if (vm.month == 9) {
        return "Outubro";
      } else if (vm.month == 10) {
        return "Novembro";
      }
      return "Dezembro";
    },
  },
  data() {
    return {
      month: 1,
      value: 0,
      limit: 0,
      json_fields: {
        Valor: {
          field: "value",
          callback: (value) => {
            return `R$ ${(+value).toFixed(2)}`;
          },
        },
        Data: {
          field: "createdAt",
          callback: (value) => {
            return moment(String(value)).format("DD/MM/YYYY");
          },
        },
      },
      billet: {
        id: null,
      },
      userType: '2',
      payment: false,
      duedate: null,
      tableData: [],
      ruleForm: {
        customer: "",
        month: 1,
      },
    };
  },
};
</script>
<style>
.right {
  float: right;
}

.label {
  font-weight: bold;
}

.border-ok {
  border-left: 2px solid green !important;
}

.border-nok {
  border-left: 2px solid red !important;
}

.bold {
  font-weight: bold !important;
}

.description {
  font-size: small;
}

.valor {
  font-size: 28px;
}
</style>